import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import { useDispatch, useSelector } from 'react-redux';
import { galleryActions } from '../actions';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@mui/material';

const handleDragStart = (e) => e.preventDefault();



function Carrousel({ isBannerBig, image, productsLanzamiento }) {
  const account = useSelector((state) => state.account);
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const theme = useTheme()
  const md = useMediaQuery(theme.breakpoints.only("md"))
  const sm = useMediaQuery(theme.breakpoints.only("sm"))
  const mobile = useMediaQuery(theme.breakpoints.down("md"))

  const styles = {
    bannerCatalogo: {
      width: "50vw",
      height: "32.5vh",
      objectFit: "fill",
    },
    bannerCatalogoMobile: {
      width: "100vw",
      height: "25vh",
      objectFit: "cover",
    },
    blackDiv: {
      width: "100vw",
      lineHeight: "20px",
      padding: "10px",
      fontSize: "12px",
      backgroundColor: "black",
      color: "white",
      fontWeight: "0",
      fontFamily: 'BRFirma-Light,sans-serif',
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer"
    },
    greenDiv: {
      width: "100vw",
      lineHeight: "25px",
      padding: "10px",
      fontSize: "25px",
      backgroundColor: "#9bcd65",
      color: "black",
      fontWeight: "0",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      letterSpacing: "0.3rem"
    },
  };


  const setLanzamientos = (categoria = "", promocion = "") => {
    dispatch(galleryActions.setSearchTerm(""))
    dispatch(galleryActions.setCategoria(categoria))
    dispatch(galleryActions.setRubro(""))
    dispatch(galleryActions.setSubRubro(""))
    dispatch(galleryActions.setPromocion(promocion))
    navigate("/catalogo")
  }

  const navigateToDistribuidores = () => {
    navigate("/register")
  }

  const catalogo = [
    <div style={styles.greenDiv} onDragStart={handleDragStart} role="presentation" onClick={() => navigateToDistribuidores()}>HAGASE DISTRIBUIDOR</div>,
    <div style={styles.greenDiv} onDragStart={handleDragStart} role="presentation" onClick={() => setLanzamientos("", "LANZAMIENTOS")}>VISITE NUESTROS NUEVOS LANZAMIENTOS</div>,
    <div style={styles.greenDiv} onDragStart={handleDragStart} role="presentation" onClick={() => setLanzamientos("", "LANZAMIENTOS")}>PORTAL EXCLUSIVO PARA LIBRERÍAS</div>,
  ];

  const logginCatalogo = [
    <div style={styles.blackDiv} onDragStart={handleDragStart} role="presentation" onClick={() => setLanzamientos("", "DESTACADOS")}>NUESTROS DESTACADOS</div>,
    <div style={styles.blackDiv} onDragStart={handleDragStart} role="presentation" onClick={() => setLanzamientos("", "LANZAMIENTOS")}>VISITE NUESTROS NUEVOS LANZAMIENTOS</div>,
  ]

  const homeCatalogo = [
    <img style={mobile ? (sm ? {} : styles.bannerCatalogoMobile) : styles.bannerCatalogo} src={image} onDragStart={handleDragStart} alt='catalogo-1' />,
    <img style={mobile ? (sm ? {} : styles.bannerCatalogoMobile) : styles.bannerCatalogo} src={image} onDragStart={handleDragStart} alt='catalogo-2' />
  ];
  const imageCondition =
    isBannerBig ? homeCatalogo : (account.isLoggedIn ? logginCatalogo : catalogo)

  return (
    <AliceCarousel
      mouseTracking
      autoPlayStrategy="none"
      autoPlayInterval={isBannerBig ? 6000 : 5000}
      animationDuration={isBannerBig ? 4500 : 4000}
      items={productsLanzamiento ? image : imageCondition}
      infinite autoPlay
      autoWidth
      disableButtonsControls
      disableDotsControls={!productsLanzamiento}
    />
  );
}

export default Carrousel;
